export default "__VITE_ASSET__5816793a__"